import React from 'react';
import { Route } from 'react-router-dom';
import NAACDashboard from '@/pages/naac/NAACDashboard';

export const naacDashboardRoutes = (
  <React.Fragment>
    <Route path="naac-dashboard" element={<NAACDashboard />} />
    <Route path="naac" element={<NAACDashboard />} />
  </React.Fragment>
);
